import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import LocalDBContext from "../../helpers/LocalDBContext";
import { DateUtility, nameFormatting } from "../../helpers/commonFunction";
import { useSelector } from "react-redux";
import { CustomImageCard } from "../../components";
import { getMediaFileFromDB } from "../../helpers/offlineAPIs";
const MemoizedImageCard = React.memo(CustomImageCard);

const Reports = () => {
  const { localDBList } = useContext(LocalDBContext);
  const { takedDetails } = localDBList;
  const { user } = useSelector((state) => state.userReducer);
  const [newTakedDetailList, setNewTakedDetailList] = useState([]);

  useEffect(() => {
    const handleInitialData = async () => {
      if (Array.isArray(takedDetails) && takedDetails?.length > 0) {
        const newData = await Promise.all(
          takedDetails.map(async (item) => {
            let newImages = [...item?.images];
            for (let i = 0; i < newImages?.length; i++) {
              const currImage = newImages[i];
              if (
                !currImage?.base64 ||
                !currImage?.base64?.includes("base64")
              ) {
                delete currImage?.base64;
                const base64 = await getMediaFileFromDB(
                  currImage,
                  "image_url",
                  "base64"
                );
                newImages[i] = {
                  ...currImage,
                  base64: base64,
                };
              }
            }
            return {
              ...item,
              images: newImages,
            };
          })
        );
        setNewTakedDetailList(newData);
      }
    };
    handleInitialData();
  }, [takedDetails]);

  return (
    <>
      <div className="tc-content-wrapper">
        <div className="fog-table-wrapper tc-table-wrapper">
          <Table responsive className="tc-table table fog-table">
            <thead>
              <tr>
                <th>Schedule</th>
                <th>Restaurant Personnel</th>
                <th>Date/Time</th>
                <th>Location</th>
                {Array.isArray(newTakedDetailList) &&
                newTakedDetailList.length > 0 ? (
                  (() => {
                    const maxAttachments = Math.max(
                      ...newTakedDetailList.map((item) =>
                        item.images && typeof item.images === "string"
                          ? Array.isArray(JSON.parse(item.images))
                            ? JSON.parse(item.images)?.length
                            : 0
                          : Array.isArray(item.images)
                          ? item.images?.length
                          : 0
                      )
                    );
                    return Array.from(
                      { length: maxAttachments },
                      (_, index) => (
                        <th key={`attachment-${index}`}>
                          ATTACHMENT {index + 1}
                        </th>
                      )
                    );
                  })()
                ) : (
                  <th>ATTACHMENT 1</th>
                )}
              </tr>
            </thead>
            <tbody>
              {!Array.isArray(newTakedDetailList) ||
              newTakedDetailList?.length === 0 ? (
                <tr>
                  <td colSpan={5}>No data to display</td>
                </tr>
              ) : (
                newTakedDetailList.map((item, i) => {
                  const imagesArr =
                    item?.images && typeof item?.images === "string"
                      ? Array.isArray(JSON.parse(item?.images))
                        ? JSON.parse(item?.images)
                        : []
                      : Array.isArray(item?.images)
                      ? item?.images
                      : [];

                  const maxAttachments = Math.max(
                    ...newTakedDetailList.map((itm) =>
                      itm.images && typeof itm.images === "string"
                        ? Array.isArray(JSON.parse(itm.images))
                          ? JSON.parse(itm.images)?.length
                          : 0
                        : Array.isArray(itm.images)
                        ? itm.images?.length
                        : 0
                    )
                  );
                  return (
                    <tr key={i}>
                      <td className="min-width-150">
                        {item?.recode_time
                          ? DateUtility.mmddyywithDay(item?.recode_time)
                          : "-"}
                      </td>
                      <td className="min-width-180">
                        {item?.app_user || nameFormatting(user, "LF") || "-"}
                      </td>
                      <td className="min-width-180">
                        {item?.recode_time
                          ? DateUtility.mmddyyWithHHMM(item?.recode_time)
                          : "-"}
                      </td>
                      <td className="min-width-300">
                        {item?.address
                          ? item?.address
                          : item?.latitude
                          ? "Not yet available"
                          : "-"}
                      </td>
                      {Array.from({ length: maxAttachments }, (_, index) => (
                        <td key={`attachment-${i}-${index}`}>
                          {imagesArr?.[index]?.image_url ||
                          imagesArr?.[index]?.base64 ? (
                            <span role="button">
                              <MemoizedImageCard
                                src={
                                  imagesArr?.[index]?.base64 &&
                                  imagesArr?.[index]?.base64?.includes("base64")
                                    ? imagesArr?.[index]?.base64
                                    : process.env.REACT_APP_IMAGE_URL +
                                      imagesArr[index]?.image_url
                                }
                                alt={`Attachment ${index + 1}`}
                                width={100}
                                imagePreview={true}
                              />
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default Reports;
